import { useEffect, useState } from 'react';
import { DOCUMENTATION } from 'constants/statusProcess';

export const useDocumentationRetry = ({
    actions,
    doTagDocumentRetry,
    doTagDocumentRetryDocClose,
    doTagDocumentRetryThanksClose,
    doTagModalDocumentationRetry,
    isDocumentationLoaded,
    isDocumentationUploaded,
    userProfile,
    isDocumentRetryBeenShown,
    setIsDocumentRetryBeenShown,
}) => {
    const [isDocumentRetryRequestVisible, setIsDocumentRetryRequestVisible] = useState(false);
    const [isDocumentRetryThanksVisible, setIsDocumentRetryThanksVisible] = useState(false);

    const { documentationStatusCounter, status } = userProfile;

    const isDocumentRetry = () =>
        status === DOCUMENTATION && !isDocumentationUploaded && documentationStatusCounter > 0;

    const handleDocumentRetryThanksClose = etiquetaEvento => {
        setIsDocumentRetryThanksVisible(false);
        doTagDocumentRetryThanksClose(etiquetaEvento);
    };

    const handleDocumentRetryDocClose = etiquetaEvento => {
        setIsDocumentRetryRequestVisible(false);
        doTagDocumentRetryDocClose(etiquetaEvento);
    };

    useEffect(() => {
        isDocumentRetry() && actions.hideWelcomeCard();
    }, []);

    useEffect(() => {
        if (
            isDocumentationUploaded &&
            isDocumentationLoaded &&
            isDocumentRetryBeenShown &&
            documentationStatusCounter > 0
        ) {
            setIsDocumentRetryThanksVisible(true);
            doTagModalDocumentationRetry();
        }
    }, [isDocumentationUploaded, isDocumentationLoaded, isDocumentRetryBeenShown, documentationStatusCounter]);

    useEffect(() => {
        if (isDocumentRetry() && !isDocumentRetryBeenShown) {
            setIsDocumentRetryRequestVisible(true);
            setIsDocumentRetryBeenShown(true);
            doTagDocumentRetry();
        }
    }, [isDocumentRetry, isDocumentRetryBeenShown]);

    return {
        isDocumentRetry,
        isDocumentRetryRequestVisible,
        isDocumentRetryThanksVisible,
        handleDocumentRetryDocClose,
        handleDocumentRetryThanksClose,
    };
};
